<template>
  <div class="pv">
    <div class="pv__search">
      <span class="pv__search-icon">🔍</span>
      <span class="pv__search-text">{{ run && phase > 0 ? '夏季女装连衣裙 宽松 1688' : '等待搜索...' }}</span>
      <span v-if="phase > 0" class="pv__search-ai">AI选品</span>
    </div>
    <div
      v-for="(item, i) in items"
      :key="item.n"
      class="pv__item"
      :style="{ opacity: (phase > 1 && run) || (phase > 0 && i === 0) ? 1 : 0, transform: (phase > 1 && run) || (phase > 0 && i === 0) ? 'translateX(0)' : 'translateX(16px)' }"
    >
      <span class="pv__item-img">👗</span>
      <span class="pv__item-name">{{ item.n }}</span>
      <span class="pv__item-price">{{ item.price }}</span>
      <span class="pv__item-score">{{ item.score }}</span>
    </div>
    <div v-if="phase > 1 && run" class="pv__done">✦ AI推荐完成 — 共找到 1,247 件商品</div>
  </div>
</template>

<script>
export default {
  name: 'PrevSearch',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      phase: 0,
      timers: [],
      items: [
        { n: '韩版连衣裙', score: 94, price: '¥32' },
        { n: '棉麻T恤夏款', score: 87, price: '¥24' },
        { n: '牛仔短裤女', score: 82, price: '¥38' }
      ]
    }
  },
  watch: {
    run(v) {
      this.timers.forEach(t => clearTimeout(t))
      this.timers = []
      if (!v) { this.phase = 0; return }
      this.timers.push(setTimeout(() => { this.phase = 1 }, 800))
      this.timers.push(setTimeout(() => { this.phase = 2 }, 1600))
    }
  },
  beforeDestroy() {
    this.timers.forEach(t => clearTimeout(t))
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .05);
  border: 1px solid rgba(255, 255, 255, .1);
  margin-bottom: 8px;
}
.pv__search-icon { font-size: 11px; opacity: .5; }
.pv__search-text {
  font-size: 11px;
  color: rgba(240, 230, 210, .6);
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}
.pv__search-ai { font-size: 9px; color: #00C8F5; }
.pv__item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 8px;
  border-radius: 7px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(255, 255, 255, .07);
  margin-bottom: 5px;
  transition: all .4s;
}
.pv__item-img {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: linear-gradient(135deg, rgba(139, 92, 246, .3), rgba(59, 130, 246, .25));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.pv__item-name { font-size: 11px; color: rgba(240, 230, 210, .8); flex: 1; }
.pv__item-price { font-family: Inter, monospace; font-size: 11px; color: #D4A946; font-weight: 600; }
.pv__item-score {
  padding: 1px 6px;
  border-radius: 6px;
  background: rgba(212, 169, 70, .2);
  border: 1px solid rgba(212, 169, 70, .4);
  font-family: Inter;
  font-size: 9px;
  color: #D4A946;
}
.pv__done {
  text-align: center;
  font-size: 10px;
  color: #00C8F5;
  margin-top: 4px;
  animation: gx-revealUp .3s both;
}
</style>
